<template>
  <div>
    <div class="panel" v-if="project">
      <div class="panel-body">
        <div>
          <p class="h6">
            项目：{{ project.pit_number }}（{{ project.pit_team }}）
          </p>
          <el-table border size="small" :data="trips" style="width: 100%">
            <el-table-column prop="enter_time" label="入井时间">
            </el-table-column>
            <el-table-column prop="out_time" label="起出时间">
            </el-table-column>
            <el-table-column prop="stratum" label="所钻地层"> </el-table-column>
            <el-table-column prop="drill_footage" label="进尺(m)">
            </el-table-column>
            <el-table-column prop="drill_time" label="纯钻时间(h)">
            </el-table-column>
            <el-table-column prop="drill_speed" label="机械钻速(m/h)">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <p v-else class="text-center mt-20">无项目信息。</p>
  </div>
</template>

<script>
import { drillProjectInfo } from '@/service/getData'
export default {
  props: {
    serialNumber: String,
  },
  data() {
    return {
      project: null,
      trips: [],
    }
  },
  watch: {
    serialNumber() {
      this.getData()
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await drillProjectInfo(this.serialNumber)
      if (res.status == 0 && res.data.id) {
        this.project = res.data
        this.trips = res.data.drill_trips || []
      } else {
        this.project = null
        this.trips = []
      }
    },
  },
}
</script>